// サイト内共通のアコーディオン処理

// ▼デフォルト挙動が複数パターンあるので注意
// TOP-FAQ：PC/SPどちらも閉じるがデフォルト
// インタビュー一覧（絞り込み）：PCアコーディオンなし・SPは開いた状態がデフォ
// インタビュー詳細（目次）：PCアコーディオンなし・SPは開いた状態がデフォ
// JOBS：
// DATA：

export class Accordion {
  constructor() {
    this.DOM = {};
    this.DOM.accordionItems = document.querySelectorAll('[data-accordion]');

    // ブレイクポイントの定義 (例: 767px以下をSPとする)
    this.mediaQuery = window.matchMedia('(max-width: 767px)');

    this.CLASS = {
      IS_OPENED: 'is-opened'
    };

    if (this.DOM.accordionItems.length === 0) return;

    this.init();
  }

  init() {
    // 1. レスポンシブ初期状態のセットアップ
    this.setupInitialState();

    // 2. 画面リサイズ・回転時の監視
    this.mediaQuery.addEventListener('change', () => {
      this.setupInitialState();
    });

    // 3. クリックイベント登録
    this.bindEvents();
  }

  /**
   * data-accordion="sp-first-open" が指定されているアイテムの初期開閉制御
   */
  setupInitialState() {
    const isSP = this.mediaQuery.matches;

    // sp-first-open が指定されている要素のみ抽出
    const targetItems = Array.from(this.DOM.accordionItems).filter(
      (item) => item.dataset.accordion === 'sp-first-open'
    );

    targetItems.forEach((item, index) => {
      const target = item.querySelector('[data-accordion-target]');
      if (!target) return;

      if (isSP) {
        // 【SP時】1個目（index === 0）だけ開き、2個目以降は閉じる
        if (index === 0) {
          this.open(item, target);
        } else {
          this.close(item, target);
        }
      } else {
        // 【PC時】すべて開く
        this.open(item, target);
      }
    });
  }

  /**
   * クリックイベントの登録
   */
  bindEvents() {
    this.DOM.accordionItems.forEach((item) => {
      const trigger = item.querySelector('[data-accordion-trigger]');
      const target = item.querySelector('[data-accordion-target]');

      if (!trigger || !target) return;

      trigger.addEventListener('click', (event) => {
        event.preventDefault();

        const isOpen = item.classList.contains(this.CLASS.IS_OPENED);

        if (isOpen) {
          this.close(item, target);
        } else {
          this.open(item, target);
        }
      });
    });
  }

  /**
   * 開く処理
   */
  open(item, target) {
    // インラインスタイルが未設定（または 0px）の場合、明示的に '0px' をセットしてリフローを発生させる
    if (target.style.height === '' || target.style.height === '0px') {
      target.style.height = '0px';
      target.offsetHeight; // リフロー（レンダリング再計算）の強制
    }

    item.classList.add(this.CLASS.IS_OPENED);
    target.style.height = `${target.scrollHeight}px`;
  }

  /**
   * 閉じる処理
   */
  close(item, target) {
    if (target.style.height === '' || target.style.height === 'auto') {
      target.style.height = `${target.scrollHeight}px`;
      target.offsetHeight; // リフロー強制
    }

    item.classList.remove(this.CLASS.IS_OPENED);
    target.style.height = '0px';
  }
}
